/**
 * Imports
*/

// utils
import lang from '../../misc/i18n.js';
import InstabergUtils from '../../misc/utils.js';

/**
 * WordPress dependencies
*/
const { __, _n, sprintf } = wp.i18n;
const { Component, render, findDOMNode, Fragment } = wp.element;

/**
 * Config
*/
const localizationName = 'instaberg';
const alias = 'AAInstaberg-View-';



/**
 * React Components
*/
class InstabergViewGrid_ListItem extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isHovered: false
    };
  }

  render()
  {
    let { isHovered } = this.state;
    let isHoveredCss = isHovered ? `${alias}hover-state` : '';

    const { video } = this.props;
    let { image, total_comments, total_likes, caption, link, post_type } = video;

    const styleGridImg = {
      backgroundImage: `url(${image})`,
    };

    total_likes = 'undefined' === typeof total_likes ? 0 : total_likes;
    total_likes = InstabergUtils.humanFormat( total_likes );

    total_comments = 'undefined' === typeof total_comments ? 0 : total_comments;
    total_comments = InstabergUtils.humanFormat( total_comments );

    return (
      <div
        className={ `${alias}element` }
        data-key={ video.id }
        onMouseEnter={ (e) => { this.handleMenuHover( e ) } }
        onMouseLeave={ (e) => { this.handleMenuHover( e ) } }
        onClick={ (e) => { this.handleMenuClick( e, { videoid: video.id, image, post_type } ) } }
      >

        <div className={ `${alias}overlay ${isHoveredCss}` }>
          <div className={ `${alias}classic1-overlay-misc` }>

            <span className={ `${alias}misc-likes` }>
              <a href={ link } target="_blank" style={{ fontFamily: this.props.pcstyle.fontFamily }}><i className="mi-icon mi-icon-heart4"></i>{ total_likes }</a>
            </span>
            <span className={ `${alias}misc-comments` }>
              <a href={ link } target="_blank" style={{ fontFamily: this.props.pcstyle.fontFamily }}><i className="mi-icon mi-icon-bubble2"></i>{ total_comments }</a>
            </span>

          </div>

          <p style={ this.props.pcstyle }>
            { caption }
          </p>
        </div>
        <div className={ `${alias}img` }>
          { '' !== image ? <img src={ image } /> : '' }
          { InstabergUtils.itemShowIcon( post_type ) }
        </div>

      </div>
    );
  }

  handleMenuHover( event )
  {
    this.setState({
      isHovered: ! this.state.isHovered
    });
  }

  handleMenuClick( event, pms )
  {
    event.preventDefault();
    this.props.onClickListItem( pms );
  }
}

class InstabergViewGrid extends Component {

  constructor(props) {
    super(props);
  }

  render()
  {
    return ( this.PrintVideosList() );
  }

  shadeColor(color, percent)
  {
    var R = parseInt(color.substring(1,3),16);
    var G = parseInt(color.substring(3,5),16);
    var B = parseInt(color.substring(5,7),16);

    R = parseInt(R * (100 + percent) / 100);
    G = parseInt(G * (100 + percent) / 100);
    B = parseInt(B * (100 + percent) / 100);

    R = (R<255)?R:255;
    G = (G<255)?G:255;
    B = (B<255)?B:255;

    var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
    var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
    var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));

    return "#"+RR+GG+BB;
  }

  PrintVideoSingleElement( video )
  {
    const main_color = this._get_option('primaryColor')['text_color'];
    const main_text_size = this._get_option('primaryColor')['font_size'];
    const main_text_family = this._get_option('primaryColor')['font_family'];

    let pcstyle = {
      background: `linear-gradient(135deg, ${this.shadeColor( main_color, -20 )} 0%, ${this.shadeColor( main_color, 60 )} 100%)`,
      '-webkit-background-clip': 'text',
      '-webkit-text-fill-color': 'transparent',
      fontSize: `${main_text_size}px`,
      fontFamily: main_text_family
    };

    return (
      <InstabergViewGrid_ListItem
        pcstyle={ pcstyle }
        video={ video }
        onClickListItem={ (pms) => { this.props.onClickListItem( pms ) } }
      />
    );
  }

  PrintVideosList()
  {
    const { layoutType } = this.props.options;
    let { videos } = this.props;
    const gridCols = parseInt( this._get_option('gridCols') );

    if ( ! videos.length ) {
      return '';
    }

    const video_list = videos.map( video => {
      return ( this.PrintVideoSingleElement( video ) );
    });

    return (
      <React.Fragment>
        <div
          className={ `${alias}classic1-grid ${alias}${gridCols}col` }
        >
          { video_list }
        </div>
      </React.Fragment>
    );
  }

  //============================================================================================
  // MISC
  _get_option( opt_name )
  {
    let options = this.props.options;

    let opt = null;
    if ( InstabergUtils.isset( options, opt_name ) ) {
      opt = options[ opt_name ];
    }
    return opt;
  }

}
export { InstabergViewGrid };



// WEBPACK FOOTER //
// ./wp-content/plugins/instaberg/src/templates/grid/tpl.view.js